import React from 'react';
import './Services.css';
import ProjectShowcase from './cryptoProjectShowcase';
import SaasSolutions from './saasSolutions';
import CloudDigital from './cloudDigital';
import VentureProjects from './ventureProjects';
import { FaGithub, FaInstagram, FaLinkedin, FaEnvelope, FaPhone } from 'react-icons/fa';

const ServiceCard = ({ title, description, icon }) => (
  <div className="service-card">
    <div className="card-header">
      <span className="card-icon">{icon}</span>
      <h3>{title}</h3>
    </div>
    <div className="card-content">
      <p>{description}</p>
    </div>
  </div>
);

const ContactInfo = () => (
  <div className="contact-info-container">
    <h2>Get in Touch</h2>
    <div className="contact-info">
      <a href="https://github.com/Ashishkr05" target="_blank" rel="noopener noreferrer">
        <FaGithub /> GitHub
      </a>
      <a href="https://www.instagram.com/ashishkr_05?igsh=Z256bHV1dGNiN2pt" target="_blank" rel="noopener noreferrer">
        <FaInstagram /> Instagram
      </a>
      <a href="https://www.linkedin.com/in/ashish-kumar-b180821aa/" target="_blank" rel="noopener noreferrer">
        <FaLinkedin /> LinkedIn
      </a>
      <a href="mailto:ashishbgs9783@gmail.com.com">
        <FaEnvelope /> ashishbgs9783@gmail.com
      </a>
      <a href="tel:+919783891474">
        <FaPhone /> +91 9783891474
      </a>
    </div>
  </div>
);

const Services = () => {
  const services = [
    {
      title: "Software Development",
      description: "Custom software solutions tailored to your business needs, from concept to deployment.",
      icon: "💻"
    },
    {
      title: "Full-Stack Development",
      description: "End-to-end web solutions using the latest frontend and backend technologies.",
      icon: "🌐"
    },
    {
      title: "Blockchain Development",
      description: "Building decentralized applications and smart contracts on various blockchain platforms.",
      icon: "🔗"
    },
    {
      title: "Cryptocurrency Solutions",
      description: "Developing secure and efficient cryptocurrency wallets, exchanges, and trading platforms.",
      icon: "💰"
    },
    {
      title: "Cybersecurity",
      description: "Implementing robust security measures to protect your digital assets and infrastructure.",
      icon: "🛡️"
    },
    {
      title: "AI & Machine Learning",
      description: "Leveraging artificial intelligence to create intelligent and predictive applications.",
      icon: "🤖"
    }
  ];

  return (
    <div className="services-background">
      <div className="services-container">
        <h2>My Services</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <ServiceCard key={index} {...service} />
          ))}
        </div>
      </div>
      <div className="project-showcase-wrapper">
        <ProjectShowcase />
        <SaasSolutions />
        <CloudDigital />
        <VentureProjects />
      </div>
      <ContactInfo />
    </div>
  );
}

export default Services;